// to add new version history, paste in the md that you received from the PM at the top of the md. include <br/> <hr/> <br/> between each version history.

export const VersionHistoryList = `
    # **3.1.2**
    **Smokejumper Reporting System v3.1.2 Patch**<br>
    August 25, 2025<br><br>
    **About this release:**<br>
    Smokejumper Reporting System v3.1.2 contains a patch to version 3.1.1. The production application (https://smj.fs2c.usda.gov) has been updated to include the following:
    <br><br>
    **Fixed in this release:**
    <br><br>
    1.	Drogue and Reserve Riggers in new MARS Incident would not always save.<br>
    <br/>
    <hr/>
    <br/>


    # **3.1.1**
    **Smokejumper Reporting System v3.1.1 Patch**<br>
    July 15, 2025<br><br>
    **About this release:**<br>
    Smokejumper Reporting System v3.1.1 contains a patch to version 3.0.2. The production application (https://smj.fs2c.usda.gov) has been updated to include the following:
    <br><br>
    **Fixed in this release:**
    <br><br>
    1.	Spotter originally assigned as Trainee on Incident where they should have been assigned as spotter, can now reassign and assign correctly.<br>
    2.  Spotter / Trainee dropdowns now allow blanks, for un-assigning.<br>
    3.  Fixed Parachute reports, so they do not filter on Jumper ActiveStatus.<br>
    4.  Replaced legacy mapping component no longer supported (Automapper) with Mapster.<br>
    5.  Pre2004Jumps:<br>
    &nbsp;&nbsp;&nbsp;-The "total" field will no longer be used in any calculations<br>
		&nbsp;&nbsp;&nbsp;- The adjustments will be included in:<br>
		&nbsp;&nbsp;&nbsp;- Individual Jump Records<br>
		&nbsp;&nbsp;&nbsp;- Jumper Status on MARS / Incident / Jumper tab<br>
    <br><br>
    **Updated in this release:** 
    <br><br>
    &nbsp;&nbsp;&nbsp;1 - Imported BLM MARS Incidents from spreadsheets<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- NOTE: Legacy data from the BLM import wil have much of the jumper info, stats, etc in the Notes for each MARS form section.<br>
    <br><br>
    **New in this release:**
    <br>
    1.  Added new Sysadmin option to edit the Pre2004Jumps Adjustments.<br>
    <br/>
    <hr/>
    <br/>
    

    # **3.0.3**
    **Smokejumper Reporting System v3.0.3 Patch**<br>
    May 19, 2025<br><br>
    **About this release:**
    Smokejumper Reporting System v3.0. contains a patch to version 3.0.2. The production application (https://smj.fs2c.usda.gov) has been updated to include the following:
    <br><br>
    **Fixed in this release:**
    <br><br>
    1.	Pre2004Jumps - we have finilized the logic for using the adjustments coming from the Pre2004Jumps table. All adjustments will be used, EXCEPT the adjusment for the total jumps.<br>
    2.  Addressed issue where some incidents were causing the 'forever spinner' when trying to edit them.  
    <br/>
    <hr/>
    <br/>
    
    # **3.0.2**
    **Smokejumper Reporting System v3.0.2 Patch**<br>
    Apr 8, 2025<br><br>
    **About this release:**
    Smokejumper Reporting System v3.0. contains a patch to version 3.0.1. The production application (https://smj.fs2c.usda.gov) has been updated to include the following:
    <br><br>
    **Fixed in this release:**
    1.	Selecting Base in Jumper section of MADB add/edit Incident results in endlessly spinning circle SRS-249

    <br/>
    <hr/>
    <br/>

    # **3.0.1**
    **Smokejumper Reporting System v3.0.1 Patch**  
    Mar ~4, 2025
    
    **About this release:** 
    Smokejumper Reporting System v3.0.1 contains a patch to version 3.0.0. The production application (https://smj.fs2c.usda.gov) has been updated to include the following:

    **New in this release:**  
    1.	New department field added to the MARS Artifacts form  
    2.	New checkboxes added for the MARS Incident form for Manufacturing Error and Cargo-in-Tow  
    3.	Migrate 715 legacy MARS BLM Incident records with new classifications  
    4.	New “N/A” category selections in MARS Aircraft, Gear/Equipment and Procedure  
    5.	Confirmations and user help for Finalizing a MARS incident:  
      > a.	Changed “Update” button to say “Save Draft”  
      b.	Added draft icon to the “Save Draft” button  
      c.	Added lock icon to the “Finalize” button  
      d.	Made “Save Draft” and “Finalize” buttons different  
      e.	Added “Save Draft” button to Summary tab   
      f.	Added a pop-up confirmation when user selects “Finalize”  
      g.	Add User Info text to Summary tab: 

     *Finalize Incident  
     •	Only the creator of the incident or a MARS Admin can finalize an incident.  
     •	Once an incident is finalized, it will be locked and no longer editable.  
     •	Only MARS Admin can convert it back to a draft for editing  
     •	If the incident still has values that need to be updated by yourself or others, just save the draft.”*

    **Changed in this release:**  
    1.	Removed Para-cargo dropdown field from MARS Incident form  
    2.	Removed Spike Base field from MARS Reserve Parachutes Rigging Location  
    3.	Log Out button removed  
    4.	Upgraded Angular version 14 to version 15  


    **Fixed in this release:**  
    1.	System Admin, Manage Users update button not enabling  
    2.	Pilots and Copilots are not showing in records if marked as inactive  
    3.	“Pre-2004” jumps were incorrectly shown in the Individual Jumper Report  
    4.	Master Action name and To Area not saving in MARS Incidents  
    5.	Email notifications for MARS Incidents  
    6.	Master Action Incident loading time and duplicate saves  
    
    <br/>
    <hr/>
    <br/>

    # **3.0.0**
    **Smokejumper Reporting System v3.0.0**  
    02-07-25

    **About this release:**  
    The Chief Information Office, Application Development Team is pleased to announce the release of the Smokejumper Reporting System Version 3.0, a fully modernized application designed to enhance efficiency and user experience for Forest Service and Bureau of Land Management smokejumpers.  
    The Smokejumper Reporting System seamlessly merges the functionalities of the legacy Master Action Database (MADB) and the Malfunction and Abnormality Reporting System (MARS), providing a comprehensive solution tailored to modern operational needs.  
    By consolidating all smokejumper applications into a single, intuitive platform, the necessity of navigating multiple systems is eliminated. Data entered once can now be utilized for various purposes. This transformation underscores the commitment to equipping smokejumpers with the necessary tools for efficient and effective reporting and record-keeping, ultimately optimizing operations and enhancing safety.  

    **New in this release:**  
    1.	Unified Interface: A single, user-friendly interface for accessing all reporting functionalities of both Master Action and Malfunctions and Abnormalities.  
    2.  Integrated Database: A shared database improves accuracy, improves reporting and eliminates redundancy in data entry.  
    3.  Improved Dashboard: A modernized dashboard providing real-time metrics and points of interest.  
    4.  Mobile Accessibility: Updated to make using the application on tablets easier.  
    5.  Cloud Hosting: The system is now hosted in the Forest Service JARVIS Cloud, ensuring greater reliability, availability and scalability.  
    6.  New MARS Form: An updated Malfunction and Abnormality Reporting System (MARS) form and that streamlines submissions, making it easier and quicker for users to record incidents and giving supervisors the ability to review and finalize each incident.  
    7.  System Roles and Permissions: Enhanced capabilities for system administrators including user management and customizable automated features, like automated email preferences.  
  ` 